import { ProductType } from '@spilca/dictionary_ts/v1/dictionary_common/enum_product_pb';

export const CATEGORY_TYPE_MAP: Record<string, number> = {
  seeds: ProductType.RESOURCES_SEEDS,
  fertilize: ProductType.RESOURCES_FERTILIZE,
  microfertilizes: ProductType.RESOURCES_MICROFERTILIZE,
  chemicals: ProductType.RESOURCES_CHEMICAL,
  fuel: ProductType.RESOURCES_FUEL,
  crops: ProductType.COMMODITIES_CROPS,
  'vegetables-fruit-berry': ProductType.COMMODITIES_VEGETABLES_FRUIT_BERRY
};

export const getCategoryType = (category: string): string | undefined => {
  const type = CATEGORY_TYPE_MAP[category];
  return type !== undefined ? String(type) : undefined;
};